import React, { Fragment } from "react";
import { Box, Typography } from "@mui/material";
import dayJs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat'; // needed for parsing with format
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { useDispatch } from "react-redux";

dayJs.extend(customParseFormat); // enable parsing with format

export const TimeRange = ({ el, filterParams, setFilterParams }) => {
    const dispatch = useDispatch();

    return (
        <Fragment>
            <Typography
                variant="p"
                component="div"
                fontWeight="500"
                fontStyle="italic"
                color="#A8ADB0"
                sx={{ mb: 1 }}
            >
                {el.description}
            </Typography>

            <Box sx={{ flexGrow: 1 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['TimePicker']}>
                        <TimePicker
                            label="From"
                            ampm
                            sx={{ mb: 2, width: "100%" }}
                            onChange={(from) => {
                                dispatch(setFilterParams({
                                    ...filterParams,
                                    [`${el.fieldName}_from`]: from ? dayJs(from).format("hh:mm A") : null
                                }));
                            }}
                            value={
                                filterParams[`${el.fieldName}_from`]
                                    ? dayJs(filterParams[`${el.fieldName}_from`], "hh:mm A")
                                    : null
                            }
                        />
                    </DemoContainer>
                    <DemoContainer components={['TimePicker']}>
                        <TimePicker
                            label="To"
                            ampm
                            sx={{ width: "100%" }}
                            onChange={(to) => {
                                dispatch(setFilterParams({
                                    ...filterParams,
                                    [`${el.fieldName}_to`]: to ? dayJs(to).format("hh:mm A") : null
                                }));
                            }}
                            value={
                                filterParams[`${el.fieldName}_to`]
                                    ? dayJs(filterParams[`${el.fieldName}_to`], "hh:mm A")
                                    : null
                            }
                        />
                    </DemoContainer>
                </LocalizationProvider>
            </Box>
        </Fragment>
    );
};
